import { observer } from 'mobx-react-lite';
import MainBlock from './MainBlock';
import type { MainBlockProps, MainBlockValueProps } from './types';

export type { MainBlockProps, MainBlockValueProps };
export default observer(MainBlock); // MANUAL OVERRIDE
